import { Box } from "@chakra-ui/react";
import JsonRender from "../JsonRender";

type IProps = {
  question: IConfig[];
};

const QuizHeader = ({ question }: IProps) => {
  return (
    <Box>
      <JsonRender mode="view" content={question} />
    </Box>
  );
};

export default QuizHeader;
